import { render, staticRenderFns } from "./ModalHistoricoMonitoramento.vue?vue&type=template&id=20687bde"
import script from "./ModalHistoricoMonitoramento.vue?vue&type=script&lang=js"
export * from "./ModalHistoricoMonitoramento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports